import styles from "./SystemStatusIndicator.module.css";

export default function SystemStatusIndicator() {
  return <div className={styles.status}>CLARITYOS / READY</div>;
}
